import reframe from 'nike-re-framejs';

export function handlePushMessage(msg) {
    if (msg.payload === 'MATCH') {
        reframe.dispatch(['nikeone.matchMessage', msg.data, msg.payloadEvent]);
        return;
    }
    if (msg.payload === 'BET') {
        reframe.dispatch(['nikeone.betMessage', msg.data, msg.payloadEvent]);
        return;
    }
    console.error('Invalid payload', msg.payload, msg);
}
